{
  "id": "campaign-027",
  "name": "Mossy Park",
  "seed": "campaign:27",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    ".*.*.**.*.*.",
    "..n....K.n..",
    "............",
    "............",
    ".x......www.",
    "........www.",
    "........www.",
    "....n..n....",
    "............",
    "____________",
    ".,,.l..l....",
    ".,.ss.......",
    "...ss.......",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "dog",
      "x": 7,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 9
    }
  ],
  "generatorVersion": 3,
  "level": 27,
  "biome": "park",
  "par": {
    "reel": 6198,
    "push": 5065,
    "selfPropelled": 4842,
    "tractor": 4635,
    "zeroTurn": 3432,
    "fairway": 2058
  },
  "routeTries": {
    "par": {
      "reel": 1,
      "push": 16,
      "selfPropelled": 6,
      "tractor": 20,
      "zeroTurn": 2,
      "fairway": 6
    }
  }
}
